import { Entities, Projection, TOMCAT_URL } from 'src/common';
import { apiRequest } from 'src/actions/api/api';

export const REQUEST_BUS_REQUESTS = 'REQUEST_BUS_REQUESTS';
export const SUCCESS_FETCH_BUS_REQUESTS = 'SUCCESS_FETCH_BUS_REQUESTS';
export const FAILURE_BUS_REQUESTS = 'FAILURE_BUS_REQUESTS';

export function findOwnBusRequests(busCompany, filter, projection = Projection.DEFAULT) {
    let fetchMethod = 'findOwnBusRequests';
    let offerStatus = null;
    let offerCreated = false;
    let isArchived = false;
    switch (filter) {
        case 'MY_REQUESTS':
            break;
        case 'NO_OFFER_CREATED':
            offerCreated = true;
            break;
        case 'OFFER_CREATED':
            offerStatus = 'OPEN';
            break;
        case 'RESULTED_BOOKINGS':
            offerStatus = 'ACCEPTED';
            break;
        case 'DECLINED_OFFERS':
            offerStatus = 'DECLINED';
            break;
        case 'IS_ARCHIVED':
            isArchived = true;
            break;
        default:
            fetchMethod = 'findOwnBusRequests';
    }

    const url = new URL(
        `${TOMCAT_URL}api/${
            Entities.BUS_REQUESTS.repository
        }/search/${fetchMethod}?companyId=${busCompany}${projection ? `&projection=${projection}` : ''}`,
    );

    if (offerStatus != null) url.searchParams.append('offerStatus', offerStatus);
    url.searchParams.append('offerCreated', offerCreated);
    url.searchParams.append('isArchived', isArchived);

    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: url.toString(),
                method: 'GET',
                secondaryActionTypes: [REQUEST_BUS_REQUESTS, SUCCESS_FETCH_BUS_REQUESTS, FAILURE_BUS_REQUESTS],
                reducerIndex: 0,
                schema: Entities.BUS_REQUESTS.schema,
            }),
        );
    };
}

export function findOwnedByBusfinderIntegrationBusRequests(filter, projection = Projection.DEFAULT) {
    let fetchMethod = 'findOwnedByBusfinderIntegrationBusRequests';
    let offerStatus = null;
    let offerCreated = false;
    let isArchived = false;
    switch (filter) {
        case 'MY_REQUESTS':
            break;
        case 'NO_OFFER_CREATED':
            offerCreated = true;
            break;
        case 'OFFER_CREATED':
            offerStatus = 'OPEN';
            break;
        case 'RESULTED_BOOKINGS':
            offerStatus = 'ACCEPTED';
            break;
        case 'DECLINED_OFFERS':
            offerStatus = 'DECLINED';
            break;
        case 'IS_ARCHIVED':
            isArchived = true;
            break;
        default:
            fetchMethod = 'findOwnedByBusfinderIntegrationBusRequests';
    }

    const url = new URL(
        `${TOMCAT_URL}api/${
            Entities.BUS_REQUESTS.repository
        }/search/${fetchMethod}${projection ? `?projection=${projection}` : ''}`,
    );

    if (offerStatus != null) url.searchParams.append('offerStatus', offerStatus);
    url.searchParams.append('offerCreated', offerCreated);
    url.searchParams.append('isArchived', isArchived);

    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: url.toString(),
                method: 'GET',
                secondaryActionTypes: [REQUEST_BUS_REQUESTS, SUCCESS_FETCH_BUS_REQUESTS, FAILURE_BUS_REQUESTS],
                reducerIndex: 0,
                schema: Entities.BUS_REQUESTS.schema,
            }),
        );
    };
}
